import { useMemo } from 'react';

import type { IHeaderParams } from '@mint-lib/ag-grid/community';
import { CollapseRows, ExpandRows } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

const ExpanderCell = (props: IHeaderParams) => {
  const { displayName, api } = props;

  const isExpanded = useMemo(() => {
    let willExpand = true;

    api.forEachNode((node) => {
      if (node.group && !node.expanded) {
        willExpand = false;
      }
    });

    return willExpand;
  }, [api]);

  const toggleRows = () => {
    if (isExpanded) {
      api.collapseAll();
    } else {
      api.expandAll();
    }
    api.refreshHeader();
  };

  return (
    <div className="flex flex-row gap-2">
      <Button icon variant={'plain'} onClick={toggleRows}>
        {isExpanded ? <CollapseRows /> : <ExpandRows />}
      </Button>
      <p>{displayName}</p>
    </div>
  );
};

export { ExpanderCell };
